import * as THREE from 'three'
import Experience from '../Experience.js'
import { Float32Attribute, MathUtils } from 'three'
/*import firefliesVertexShader from './shaders/fireflies/vertex.glsl'
import firefliesFragmentShader from './shaders/fireflies/fragment.glsl'*/

export default class SegmentOne
{
    constructor()
    {
        this.experience = new Experience();
        this.scene = this.experience.scene;
        this.resources = this.experience.resources;
        this.time = this.experience.time;        
        this.increment = 20;
        this.resourceA = this.resources.items.segmentModel1A;
        this.resourceB = this.resources.items.segmentModel1B;
        this.tags = {}
        this.setTextures();
        this.setMaterial();
        this.setModel();
    }

    setTextures()
    {
        this.textures = {}
        this.textures.land = this.resources.items.s1ATexture;
        this.textures.land.flipY = false;
        this.textures.plants = this.resources.items.s1BTexture;
        this.textures.plants.flipY = false;
        this.textures.props = this.resources.items.s1CTexture;
        this.textures.props.flipY = false;
        this.textures.clouds = this.resources.items.s1DTexture;
        this.textures.clouds.flipY = false;
        this.textures.world = this.resources.items.s1ETexture;
        this.textures.world.flipY = false;
    }

    setMaterial()
    {
        this.landMaterial = new THREE.MeshBasicMaterial({
            map: this.textures.land
        })
        this.plantsMaterial = new THREE.MeshBasicMaterial({
            map: this.textures.plants
        })
        this.propsMaterial = new THREE.MeshBasicMaterial({
            map: this.textures.props
        })
        this.cloudsMaterial = new THREE.MeshBasicMaterial({
            map: this.textures.clouds
        })
        this.worldMaterial = new THREE.MeshBasicMaterial({
            map: this.textures.world
        })
        this.sectorMaterial = new THREE.MeshBasicMaterial();
        this.sectorMaterial.opacity = 0; 
        this.sectorMaterial.transparent = true;
    }

    setModel(index)
    {
        this.modelA = this.resourceA.scene.clone(true);
        this.modelB = this.resourceB.scene.clone(true);
        
        this.modelA.traverse((child)=>
        {                
            switch(child.name)
            {
                case "Land":
                    child.material = this.landMaterial;
                    break;   
               case "Plants":
                    child.material = this.plantsMaterial;
                    break;
                case "Props":
                    child.material = this.propsMaterial;
                    break;     
                case "Clouds":
                    child.material = this.cloudsMaterial;
                    break; 
                case "World":
                    child.material = this.worldMaterial;
                    break; 
            }        
        })
        this.modelB.traverse((child)=>
        {
            child.material = this.sectorMaterial;              
        })
        //console.log(counter);
        this.modelA.position.x = 18;
        this.modelB.position.x = 18;
        this.modelA.position.y = 0.2;
        this.modelB.position.y = 0.2;
        this.modelA.rotateY(MathUtils.degToRad(0))
        this.modelB.rotateY(MathUtils.degToRad(0))
        this.scene.add(this.modelA);
        this.scene.add(this.modelB);
    }

    setParticles()
    {
        this.firefliesGeometry = new THREE.BufferGeometry();
        this.firefliesMaterial = new THREE.PointsMaterial({ size: 0.1, sizeAttenuation: true });
        this.firefliesImpMaterial = new THREE.ShaderMaterial({
            vertexShader: firefliesVertexShader,
            fragmentShader: firefliesFragmentShader
        })
        this.firefliesCount = 30;
        this.positionArray = new Float32Array(this.firefliesCount * 3);
        for(let i = 0; i < firefliesCount; i++)
        {
            positionArray[i * 3 + 0] = (Math.random() - 0.5) * 4
            positionArray[i * 3 + 1] = Math.random() * 1.5
            positionArray[i * 3 + 2] = (Math.random() - 0.5) * 4
        }
        this.firefliesGeometry.setAttribute('position', new THREE.BufferAttribute(this.positionArray, 3));
        // Points
        this.fireflies = new THREE.Points(this.firefliesGeometry, this.firefliesMaterial);
        this.scene.add(this.fireflies);
    }
    unload()
    {
        this.modelA.position.x = 0;
        this.modelB.position.x = 0;
        this.modelA.position.y = 0;
        this.modelB.position.y = 0;
        this.modelA.rotateY(MathUtils.degToRad(0))
        this.modelB.rotateY(MathUtils.degToRad(0))
    }
    update()
    {        
    }
}